import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ClockIcon } from './clock.svg';

export const Clock = IconHOC(ClockIcon);
